import { useGeocodeLookupApiV1GeocodeGet } from '#/shared/api/generated/shipment/theCargoShipment'
import type { GeoCodeResponse } from '#/shared/api/generated/shipment/models'
import { useDebouncedValue } from '#/shared/lib/hooks'

export type ZipLookupResult = GeoCodeResponse

const MIN_QUERY_LENGTH = 1
const ZIP_LENGTH = 5
const DEBOUNCE_MS = 250

export function useZipLookup(query: string, options?: { enabled?: boolean }) {
  const normalized = query.trim()
  const debouncedQuery = useDebouncedValue(normalized, DEBOUNCE_MS)
  const isValid =
    debouncedQuery.length >= MIN_QUERY_LENGTH &&
    debouncedQuery.length <= ZIP_LENGTH &&
    /^\d+$/.test(debouncedQuery)
  const enabled = (options?.enabled ?? true) && isValid
  const { data, isFetching } = useGeocodeLookupApiV1GeocodeGet(
    { q: debouncedQuery },
    { query: { enabled } },
  )
  const results = data?.data ?? []
  return { results, debouncedQuery, isLoading: isFetching && enabled }
}
